import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { contactItem as deleteContact } from '../utils/urls';
import { showSuccessToast } from 'utils/showToast';

import { ErrorModal } from 'types/modalTypes';

async function deleteContacts({
  contactId,
  accountId,
}: TVariables): Promise<Response> {
  return fetch(deleteContact(accountId, contactId), {
    method: 'DELETE',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
  });
}

type TError = ErrorModal;

type TVariables = {
  contactId: number;
  accountId: number;
};

type TSnapshot = unknown;

function useDeleteContacts(
  contactId: number,
  accountId: number,
): UseMutationResult<void, TError, TVariables, TSnapshot> {
  const queryClient = useQueryClient();
  return useMutation(async () => {
    await deleteContacts({
      contactId,
      accountId,
    });
    queryClient.invalidateQueries('contact_list');
    showSuccessToast({
      message: 'Contact deleted successfully.',
    });
  });
}

export { useDeleteContacts };
